// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { deviceId } from './Device';
import { quickRigId } from './QuickRig';
import { harvestOperationId } from './HarvestOperation';
import { equipmentId } from './Equipment';
import { operatorId } from './Operator';
import { z } from 'zod';
export const deviceMembershipId = (z.number());
export const deviceMembership = z.object({
    id: deviceMembershipId,
    device_id: deviceId,
    quick_rig_id: quickRigId.nullable(),
    harvest_operation_id: harvestOperationId.nullable(),
    equipment_id: equipmentId.nullable(),
    added_at: z.date(),
    removed_at: z.date().nullable(),
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
});
export const deviceMembershipInitializer = z.object({
    id: deviceMembershipId.optional(),
    device_id: deviceId,
    quick_rig_id: quickRigId.optional().nullable(),
    harvest_operation_id: harvestOperationId.optional().nullable(),
    equipment_id: equipmentId.optional().nullable(),
    added_at: z.date().optional(),
    removed_at: z.date().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
});
export const deviceMembershipMutator = z.object({
    id: deviceMembershipId.optional(),
    device_id: deviceId.optional(),
    quick_rig_id: quickRigId.optional().nullable(),
    harvest_operation_id: harvestOperationId.optional().nullable(),
    equipment_id: equipmentId.optional().nullable(),
    added_at: z.date().optional(),
    removed_at: z.date().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
});
//# sourceMappingURL=DeviceMembership.js.map